<template>
  <div class="discount-btns">
    <van-goods-action>
      <van-goods-action-icon>
        <template>
          <div style="font-size: 14px; padding: 0px 10px">
            捡漏价<span style="color: red"
              >¥<span style="font-size: 16px;font-weight: 600;">500</span></span
            >，可转手赚<span style="color: red"
              >¥<span style="font-size: 16px;font-weight: 600;">1000</span></span
            >
          </div>
        </template>
      </van-goods-action-icon>
      <van-goods-action-button type="danger" text="" @click="onClickButton" disabled>
        <template> 立即入手 </template>
      </van-goods-action-button>
    </van-goods-action>
  </div>
</template>

<script>
export default {
  name: 'DiscountProBtnView',
  methods: {
    onClickButton () {},
    onClickService () {},
    onClickOrder () {
      this.$router.push({ name: 'mycart' }, () => {})
    }
  }
}
</script>

<style></style>
